export default "__VITE_ASSET__B0rEL8BW__"